/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { InventorySnapshotVolume } from '../models/InventorySnapshotVolume';

/**
* Properties of the original AWS EBS Volume at the time the snapshot was taken. Present only when `resourceType` is set to `AWS_EBS_VOLUME`. 
*/
export class AwsEbsVolumeSnapshotProperties {
  'volume'?: InventorySnapshotVolume;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "volume",
      "baseName": "volume",
      "type": "InventorySnapshotVolume",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsEbsVolumeSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

